import { useGetSchoolsInRedStatusQuery } from "@/services/dashboard";

const useSchoolsInRedStatus = () => {
  const { data, error, isLoading } = useGetSchoolsInRedStatusQuery();

  return {
    schoolsInRedStatus: data?.data?.items || [],
    isLoading,
    error,
  };
};

export default useSchoolsInRedStatus;
